// extracted by mini-css-extract-plugin
module.exports = {"note":"_2SEr4J","title":"_1Lxfla","steps":"_1PjQGy","buttonPlaceholder":"lKRFo1","orderButton":"_1e3hIG","shine-lines":"_2TE3qB"};